<template>
    <div class="vm-block-group" :class="[browser_size]">
        <div class="flex-box flex-justify-content-space-between">
            <div class="tab lh1 fwb fs14 p16 mr8 flex-item-1 pointer flex-box flex-a-center white-bg" :class="{ on: type == 2 }" @click="tab(2)">
              <i class="afd afd-lightning_outline fs12 mr4 fwn purple-3"></i>   
              {{$t('c.BlockGroup.text1')}}
                <span class="fwn black-3">（{{ paid_current }}/{{ paid_max }}）</span>
            </div>
            <div class="tab lh1 fwb fs14 p16 flex-item-1 pointer white-bg" :class="{ on: type == 1 }" @click="tab(1)">
                {{$t('c.BlockGroup.text2')}}
                <span class="fwn black-3">（{{ free_current }}/{{ free_max }}）</span>
            </div>
        </div>
        <template v-if="group">
          <group-card class="mt16 white-bg" :group="group" :is_show_owner="false"></group-card>
          <div class="flex-box flex-center mt16">
            <share :config="share_config" icon_text="分享电圈" class="type3 purple-icon purple" />
          </div> 
        </template>
        <btn v-if="session_user && session_user.is_verified != 1" class="p16 look3 mt24 w100 border" @click.native="$mixin_router_push(`/apply/certify`)">认证后即可使用电圈功能，3分钟认证一下吧！ →</btn>
        <div class="fs12 black-5 mt24">什么是电圈？<br>电圈是创作者与粉丝共同的交流空间，所有人都可以发帖讨论。</div>
        <template v-if="type == 2">
          <div class="purple mq mt-48-24 fwb black-8">电圈价格</div>
          <div>
            <multiselect
              class="btn look5 multiselect-permission mt16"
              :allowEmpty="false"
              v-model="permission_item"
              :options="vip_all_plans"
              track-by="name"
              label="name"
              :searchable="false"
              :show-labels="false"
              :placeholder="'绑定一个赞助方案'"
            ></multiselect>
          </div>
          <div class="fs12 black-5 mt16">电圈创建后，该方案目前在有效期内的会员也会自动加入电圈。价格可以设置为月费/季费/年费，详细见赞助方案高级选项</div>
          <!-- <div class="mt16 radio-box flex-wrap">
              <radio
                  v-for="(item, i) in price_list"
                  :key="i"
                  name="group_price"
                  v-model="group_pre[2].price"
                  @change.native="toggle"
                  :value="item"
                  class="mr48"
                  :checked="group_pre[2].price == item"
                  >¥ {{ item }} {{$t('c.BlockGroup.text3')}}</radio>
          </div> -->
        </template>
        <div class="purple mq mt-48-24 fwb black-8 fwb black-8">{{$t('c.BlockGroup.text4')}}</div>
        <div>
            <input
                type="text"
                v-model="group_pre[type].title"
                class="gl-input"
                :placeholder="$t('c.BlockGroup.text5')"
            />
        </div>
        <div class="purple mq mt-48-24 fwb black-8">{{$t('c.BlockGroup.text6')}}</div>
        <textarea-autosize
            class="gl-textarea mt16"
            :placeholder="$t('c.BlockGroup.text7')"
            v-model="group_pre[type].content"
            :min-height="180"
            :max-height="180"
        ></textarea-autosize>
        <div class="purple mq mt-48-24 fwb black-8">{{$t('c.BlockGroup.text8')}}</div>
        <div class="img-box mt16 flex-wrap">
            <div
                class="img-pre-box darkbg"
                v-if="group_pre[type].cover"
                :style="{
                    backgroundImage: `url(${$img_src({
                        src: group_pre[type].cover,
                        width: 240,
                        height: 240
                    })})`
                }"
            >
                <!-- <pic width="640" height="171" :src="cover"></pic> -->
            </div>
            <btn
                v-if="!group_pre[type].cover"
                class="upload-banner flex-align-self-end"
                :text="`<div class='fs14 text-center' style='width:240px'>${$t('c.BlockGroup.text9')} <br> ${$t('c.BlockGroup.text10')}</div>`"
            >
                <vue-core-image-upload
                    v-if="is_client"
                    class="gl-upload"
                    :crop="false"
                    @imageuploaded="image_upload"
                    @errorhandle="errorhandle"
                    text
                    :inputOfFile="upload.name"
                    :max-file-size="upload.max_file_size"
                    :url="upload.img_common_url"
                ></vue-core-image-upload>
            </btn>
            <btn
                v-else
                class="flex-align-self-end look1 mt16"
                @click.native="remove_pic"
            >{{$t('c.BlockGroup.text11')}}</btn>
        </div>
        <template v-if="type == 2">
          <div class="purple mq mt-48-24 fs14 black-8 flex-box flex-bet flex-a-center">
            <span>任意发电累计金额达到即可进圈</span>
            <switches theme="custom" color="purple" v-model="join_group_type"></switches>
          </div>
          <div class="black-3 fs12 mt8">发电任意方案，无论普通方案、独立方案或购买商品，按当下累计金额计算，达到价格即可进入电圈</div>
        </template>
        <!-- <template v-if="group_pre[type].group_id">
      <div class="purple mq mt-48-24 fwb black-8">电圈管理</div>
      <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center">
        <div>禁止新用户加入电圈</div>
        <switches v-if="this.type == 1" theme="custom" color="purple" v-model="open_pre_1"></switches>
        <switches v-if="this.type == 2" theme="custom" color="purple" v-model="open_pre_2"></switches>
      </div>
    </template>-->

        <div class="flex-box mt48">
            <btn class="size48 mq" @click.native="save">{{$t('c.BlockGroup.text12')}}</btn>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
  GET_USER_GET_GROUP,
  GET_CREATOR_EDIT_GROUP,
  GET_CREATOR_GET_GROUP_STATUS,
  POST_CREATOR_OPEN_GROUP_SWITCH
} from "@/api/config";
export default {
    data() {
        return {
            name: "",
            // price: "",
            detail: "",
            cover: "",
            price_list: [],
            // custom_price: "",

            // group_id: "",
            // title: "",
            // content: "",
            // cover: "",
            type: this.$route.query.type || 2,
            // price: "",

            free_max: "",
            free_current: "",
            paid_max: "",
            paid_current: "",
            open_pre_1: "",
            open_pre_2: "",
            group_list:[],
            vip_all_plans:[],
            join_group_type:'',
            permission_item:{
              name: '绑定一个赞助方案',
              value: -1, 
            },
            group_pre: {
                1: {
                    group_id: "",
                    title: "",
                    content: "",
                    cover: "",
                    type: 1,
                    join_group_type:'',
                }, //免费
                2: {
                    group_id: "",
                    title: "",
                    content: "",
                    cover: "",
                    type: 2,
                    price: "",
                    join_group_type:'',
                } //付费
            },
            group: null,
            members: [],
            filter_count: {},
            plan: {}
        };
    },
    computed: {
        ...mapState("app", [
            "session_user",
            "upload",
            "is_client",
            "browser_size",
            "plan_list"
        ]),
        post_data() {
            let d = this.group_pre[this.type];
            return {
                group_id: d.group_id,
                title: d.title,
                content: d.content,
                cover: d.cover,
                type: d.type,
                join_group_type: this.join_group_type ? 1 : 0,
                selected_plan: this.permission_item.plan_id,
                price:this.permission_item.value
                // price: this.custom_price || d.price || ""
            };
        },
        group_type2(){
          let group = {};
          this.group_list.forEach(v => {
            if(v.type == 2){
              group = v;
            }
          })
          return group
        },
        share_config() {
          let user_name = this.session_user && this.session_user.name;
          let group_title = this.group && this.group.title;
          return {
            url: `${location.origin}/group/${this.group.group_id}`,
            source: `${location.origin}`,
            title: `${user_name}邀你加入「${group_title}」，一起愉快交流！丨爱发电`,
            description: `快来加入${user_name}的电圈「${group_title}」，与${user_name}，还有可爱的圈友们一起愉快交流吧！ヾ(◍°∇°◍)ﾉﾞ（分享自@爱发电`,
            pic: this.group && this.group.cover,
            wx_description: this.group && this.group.content,
            group: this.group,
            plan: this.plan,
            members: this.members,
            extra_btns: [
              {
                func_name: "share_group",
                param: {
                  group: this.group,
                  plan: this.plan,
                  members: this.members
                },
                icon: `${this.GL.PIC_HOST}/static/img/icon-saveimage.png`,
                title: "保存图片并分享"
              }
            ]
          };
        }
    },
    watch: {
        permission_item(newValue, oldValue){
          if(newValue.can_jump){
            this.$router.push(newValue.can_jump)
          }
        },
        open_pre_1(newValue, oldValue) {
            if (oldValue !== "") {
                this.open_tab();
            }
        },
        open_pre_2(newValue, oldValue) {
            if (oldValue !== "") {
                this.open_tab();
            }
        }
    },
    async mounted() {
      this.init();
    },
    methods: {
        async save() {
            if (this.$http.is_run(GET_CREATOR_EDIT_GROUP)) {
                return false;
            }
            let data = await this.$http.$axios(
                GET_CREATOR_EDIT_GROUP,
                this.post_data
            );

            this.$notify({
                title: data.em,
                group: data.ec == 200 ? "success" : "error"
            });
            if (data.ec == 200) {
                this.$mixin_router_push(`/group/${data.data.group.group_id}`);
            }
        },
        async open_tab() {
            if (this.$http.is_run(POST_CREATOR_OPEN_GROUP_SWITCH)) {
                return false;
            }
            let data = await this.$http.$axios(POST_CREATOR_OPEN_GROUP_SWITCH, {
                group_id: this.group_pre[this.type].group_id,
                status: this[`open_pre_${this.type}`] == true ? 0 : 1
            });

            this.$notify({
                title: data.em,
                group: data.ec == 200 ? "success" : "error"
            });
        },
        async init() {
            if (this.$http.is_run(GET_CREATOR_GET_GROUP_STATUS)) {
                return false;
            }
            let data = await this.$http.$axios(GET_CREATOR_GET_GROUP_STATUS);

            if (data.ec == 200) {
                let d = data.data;
                // this.$emit("save");
                this.free_max = d.free_max;
                this.free_current = d.free_current;
                this.paid_max = d.paid_max;
                this.paid_current = d.paid_current;
                this.price_list = d.price_list;
                this.group_list = d.group_list;
                this.vip_all_plans = this.mixin_permission_group_list(data.data.vip_all_plans);
                if (d.group_list.length > 0) {
                    d.group_list.forEach(v => {
                        this.group_pre[v.type] = v;
                        this[`open_pre_${v.type}`] = v.open != 1;
                        if (v.type == 2) {
                          this.get_group(v.group_id)
                          this.join_group_type = v.join_group_type == 1

                          this.vip_all_plans.forEach(v2 => {
                            if(v2.plan_id == v.selected_plan){
                              this.permission_item = v2;
                            }
                          })
                        }
                    });
                }
            }
        },
        // toggle() {
        //     this.custom_price = "";
        // },
        tab(type) {
            this.type = type;
            let group_id = this.group_pre[type].group_id
            if(group_id){
              this.get_group(group_id)
            }else{
              this.group = null;
              this.members = [];
              this.filter_count = {};
              this.plan = {}
            }
        },
        async get_group(group_id) {
          if (this.$http.is_run(GET_USER_GET_GROUP) || group_id == '') {
            return false;
          }
          let data = await this.$http.$axios(GET_USER_GET_GROUP, {
            group_id,
          });

          if (data.ec != 200) {
            this.$notify({
              title: data.em,
              group: "error"
            });
            return false;
          }
          this.group = data.data.group;
          this.members = data.data.members;
          this.filter_count = data.data.filter_count;
          this.plan = data.data.plan;
        },
        focus() {
            this.group_pre[2].price = "";
        },
        image_upload(data) {
            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error"
                });
            }
            this.group_pre[this.type].cover = data.data.url;
        },
        errorhandle(err_text) {
            if (/FILE IS TOO LARGER MAX FILE/.test(err_text)) {
                err_text = `上传文件最大为: ` + err_text.split(" ").pop();
            }
            this.$notify({
                title: err_text,
                group: "error"
            });
        },
        remove_pic() {
            this.group_pre[this.type].cover = "";
        }
    }
};
</script>

<style lang="stylus" scoped>
.vm-block-group {
  .tab {
    border: 1px solid #EAEAEA;

    &.on {
      border-color: $purple;
    }
  }

  .custom-input {
    width: 100px;
    padding: 0 0 2px 0;
    margin: 0 5px;
  }

  .radio-box {
    display: flex;
    align-items: center;
  }

  .img-pre-box {
    width: 240px;
    height: 240px;
    background-size: cover;
    background-position: center;
  }

  .upload-banner {
    width: 240px;
    background: $black-05;
    color: $black-5;
    height: 240px;
    white-space: pre-wrap;
    line-height: 1.4;

    &:hover {
      background: $black-03;
    }
  }

  &.small {
    .radio-box {
      display: block;
    }

    .radio-component {
      margin-top: 16px;
    }
  }
}
</style>
